import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-SGYJX2RX.mjs";

// src/components/quantity-stepper/quantity-stepper.tsx
import React, {
  cloneElement,
  isValidElement
} from "react";

// src/hooks/use-quantity-stepper.ts
import { useCallback } from "react";
var DEFAULT_MAX_QUANTITY = 99;
var useQuantityStepper = ({
  onChange,
  value,
  min = 0,
  max = DEFAULT_MAX_QUANTITY,
  visible = true,
  stepInterval = 1
}) => {
  const onDecrement = useCallback(() => {
    onChange(value - stepInterval, "decrement" /* Decrement */);
  }, [onChange, value, stepInterval]);
  const onIncrement = useCallback(() => {
    onChange(value + stepInterval, "increment" /* Increment */);
  }, [onChange, value, stepInterval]);
  const decrementDisabled = value - stepInterval < min;
  const incrementDisabled = value + stepInterval > max;
  return {
    decrementButtonProps: {
      onClick: onDecrement,
      disabled: decrementDisabled || !visible,
      "aria-label": "Remove one",
      "data-testid": "item-options-minus-button"
    },
    incrementButtonProps: {
      onClick: onIncrement,
      disabled: incrementDisabled || !visible,
      "aria-label": "Add one",
      "data-testid": "item-options-plus-button"
    }
  };
};

// src/components/quantity-stepper/quantity-stepper.tsx
var QuantityStepper = (_a) => {
  var _b = _a, {
    visible = true,
    leftStepButton,
    rightStepButton,
    children,
    containerProps = {}
  } = _b, rest = __objRest(_b, [
    "visible",
    "leftStepButton",
    "rightStepButton",
    "children",
    "containerProps"
  ]);
  const { decrementButtonProps, incrementButtonProps } = useQuantityStepper(__spreadProps(__spreadValues({}, rest), {
    visible
  }));
  return /* @__PURE__ */ React.createElement("div", __spreadValues({}, containerProps), isValidElement(leftStepButton) && cloneElement(leftStepButton, __spreadProps(__spreadValues({}, decrementButtonProps), {
    visible
  })), children, isValidElement(rightStepButton) && cloneElement(rightStepButton, __spreadProps(__spreadValues({}, incrementButtonProps), {
    visible
  })));
};

export {
  QuantityStepper,
  useQuantityStepper
};
